const IconBolt = () => {
  return ( 
    <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24"><path d="m10.125 20.5.925-6.625H7.225L12.95 3.5h.925l-.925 6.625h3.825L11.05 20.5Z"/></svg>
  );
}

export default IconBolt;